<template>

    <div>
        <h2 class="h5">{{ label }} :</h2>
        <div class="form-group">
            <select multiple="multiple" :size="size" :name="internalFormAction?'codes[]':''" class="form-control multiple-select-column" @change.stop="selectItems" tabindex="0" ref="sel" :autofocus="initialFocus" :aria-label="helpLabel + ' pour ' + label">
                <option v-for="(choice, index) of choices" :key="choice.code" :value="choice.code" v-html="choice.name" @dblclick.stop="goto"></option>
            </select>
        </div>
        <p v-if="shouldDisplayHelp"><small><em>{{ helpLabel }}</em></small></p>
        <div class="form-group text-center" v-if="buttonVisible">
            <span class="glyphicon glyphicon-chevron-down" aria-hidden="true"></span>
            <button v-if="internalFormAction" type="submit" class="btn btn-primary btn-block" tabindex="1"><span class="glyphicon glyphicon-slightly-slide" :class="buttonIcon" aria-hidden="true"></span> {{ buttonLabel }}</button>
            <button v-else type="button" class="btn btn-primary btn-block" tabindex="1" @click.stop="goto"><span class="glyphicon glyphicon-slightly-slide" :class="buttonIcon" aria-hidden="true"></span> {{ buttonLabel }}</button>
            <button type="button" class="btn btn-primary btn-block" tabindex="1" @click.stop="gotoMap" v-if="mapButtonVisible"><span class="glyphicon glyphicon-map-marker glyphicon-slightly-slide" aria-hidden="true"></span> Cartographie de cette MRC</button>
        </div>
    </div>

</template>

<script>
import { isArray, size, forEach, indexOf } from 'lodash';
import { mapState } from 'vuex';

export default {
    name: 'multiple-select-column',

    props: {
        source: String,
        label: String,
        initialSelected: Array,
        singleInstructions: {
            type: String,
            default: 'Sélectionnez un élément',
        },
        size: {
            type: Number,
            default: 20,
        },
        displayOnSingleOnly: {
            type: Boolean,
            default: false,
        },
        canAccess: {
            type: Boolean,
            default: true,
        },
        internalFormAction: {
            type: Boolean,
            default: false,
        },
        initialFocus: Boolean,
    },

    data ()
    {
        return {
            selectCount: this.initialSelected.length,
            helpLabel: 'Sélectionnez une ou plusieurs lignes',
        };
    },

    mounted ()
    {
        forEach(this.$refs.sel.options, option =>
        {
            if (
                indexOf(this.initialSelected, parseInt(option.value, 10)) >= 0
            )
            {
                $(option).prop('selected', true);
            }
        });
        this.selectCount = this.initialSelected.length;
        // Synchronise initial Vuex state:
        this.$store.commit('SET_SELECTED_PROVINCE_REGIONS', [
            this.source,
            this.initialSelected,
        ]);
    },

    computed: {
        shouldDisplayHelp ()
        {
            if (this.selectCount > 0 || this.buttonVisible)
            {
                return false;
            }
            return size(this.choices) > 1;
        },
        buttonVisible ()
        {
            if (!this.canAccess)
            {
                return false;
            }
            if (this.selectCount > 1 && this.displayOnSingleOnly)
            {
                return false;
            }
            return this.selectCount > 0;
        },

        mapButtonVisible ()
        {
            return this.source === 'counties';
        },

        buttonIcon ()
        {
            switch (this.source)
            {
            case 'regions':
                return 'glyphicon-record';

            case 'counties':
                return 'glyphicon-check';

            case 'municipalities':
            default:
                if (this.selectCount > 1)
                {
                    return 'glyphicon-stats';
                }
                return 'glyphicon-book';
            }
        },

        buttonLabel ()
        {
            switch (this.source)
            {
            case 'counties':
                return 'Mesures en place dans cette MRC';
                break;

            case 'municipalities':
                if (this.selectCount > 1)
                {
                    return `Résultats pour ces ${
                        this.selectCount
                    } municipalités`;
                }
                return 'Rapports pour cette municipalité';
                break;

            case 'regions':
                return 'État de mise en œuvre de cette région';
                // label = (this.selectCount > 1) ? `ces ${this.selectCount} régions` : 'cette région';
            default:
                break;
            }
            return 'Données';
        },

        ...mapState({
            choices (state)
            {
                this.selectCount = 0;
                return state[this.source];
            },
        }),
    },

    methods: {
        getSelectedOptions ()
        {
            // Make this cross-browser compatible:
            return $(this.$refs.sel).find(':selected');
        },

        selectItems ()
        {
            const selectedOptions = this.getSelectedOptions();

            if (
                selectedOptions.length === 1 &&
                selectedOptions.eq(0).val() === ''
            )
            {
                this.selectCount = 0;
                this.$store.dispatch('SELECT_MULTIPLE_OPTIONS_FOR', [
                    this.source,
                    [],
                ]);
            }
            else
            {
                this.selectCount = selectedOptions.length;
                this.$store.dispatch('SELECT_MULTIPLE_OPTIONS_FOR', [
                    this.source,
                    selectedOptions,
                ]);
            }
        },

        goto ()
        {
            if (this.canAccess)
            {
                const selectedOptions = this.getSelectedOptions();

                if (selectedOptions.length)
                {
                    this.$store.dispatch('GOTO_WITH_SOURCE', [
                        this.source,
                        selectedOptions,
                    ]);
                }
            }
        },

        gotoMap ()
        {
            if (this.canAccess)
            {
                const selectedOptions = this.getSelectedOptions();

                if (selectedOptions.length === 1)
                {
                    this.$store.dispatch('GOTO_MAP_WITH_SOURCE', [
                        this.source,
                        selectedOptions[0],
                    ]);
                }
            }
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/vue/multiple-select-column.vue